import { select } from 'd3-selection'

export function appendModal () {
  return select('body')
    .div().id('fileDeleteModal')
    .clas('modal fade').attr('tabindex', '-1').attr('role', 'dialog')
    .attr('aria-hidden', 'true')
    .div().clas('modal-dialog').attr('role', 'document')
    .div().clas('modal-content rounded-0')
    .call(modalContentDiv => {
      modalContentDiv
        .div().clas('modal-header')
        .call(header => {
          header.append('h5')
            .clas('modal-title')
          header.append('button')
            .attr('type', 'button')
            .clas('close').attr('data-dismiss', 'modal').attr('aria-label', 'Close')
            .span('×').attr('aria-hidden', 'true')
        })
      modalContentDiv.div().clas('modal-footer')
        .call(body => {
          body.append('button').attr('type', 'button').text('Odustani').clas('btn btn-secondary rounded-0')
            .attr('data-dismiss', 'modal')
          body.append('button').attr('type', 'button').text('Ukloni').clas('btn btn-danger rounded-0')
            .attr('data-dismiss', 'modal')
            .id('fileRemoveConfirmButton')
        })
    })
}